import React, { PureComponent } from 'react';
import { DLModal } from 'appSrc/components/Shards';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import { PrimaryButton } from 'appSrc/components/UI';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import style from './styles/style.module.css';

import 'react-datepicker/dist/react-datepicker.css';


class NewScheduleModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            working: false,
            selectedDate: undefined,
        };
    }
    changeDate = ( date ) => {
        this.setState( { selectedDate: date } );
    }
    submitHandler = () => {
        var date = moment( this.state.selectedDate );
        this.props.onSubmit( date.format( 'MM/DD/YYYY' ) );
    }



    render() {
        const { selectedDate, working } = this.state;

        return (
            <DLModal title='Select Date' className={ style.dateModal }
            closeHandler={ this.props.closeHandler }>
                <div className={ style.content }>
                    <DatePicker className={ style.picker } inline
                    placeholderText="Click to select a date" excludeDates={ this.props.exclude }
                    selected={ selectedDate } onChange={ this.changeDate } />
                    <PrimaryButton label='Create' onClick={ this.submitHandler } />
                </div>
                { working &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
NewScheduleModal.defaultProps = {
    onSubmit: () => {},
};

export default NewScheduleModal;
